const DashIconOutline = ({ ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		id="Camada_3"
		x="0px"
		y="0px"
		viewBox="0 0 3000 3000"
		xmlSpace="preserve"
		{...props}
	>
		<style type="text/css">
			{
				"\n\t.st0{fill:none;stroke:#000000;stroke-width:210;stroke-miterlimit:10;}\n"
			}
		</style>
		<path
			className="st0"
			d="M1070.3,2818L703.6,1742.7c257.2-273.8,514.4-552,771.6-825.8c428.2,276,861.7,552,1289.9,828.1  c1.8,1.1,1,3.9-1.2,3.9l-1270.5-6.6l542.2,1037.6"
		/>
		<path
			className="st0"
			d="M703.6,1742.7l789.8-0.4c407.1-192.9,798.4-385.5,1205.5-578.4c0,0,61.6-26.5,85-18.3c19.3,6,46,80.3,46,80.3  c72,223.1,15.7,566.6,15.7,566.6c-47.6,206-86.4,375.6-308.1,627.7c-287.2,326.5-641.1,414.9-746.7,437.3  c-176.3,37.5-485.7,67-818.7-77.3c-466.7-202.3-654.5-605.4-696-701.3c-148.2-342.4-112.6-651.8-90.7-778.7  c4.9-17.8,7.1-56.5,29.3-67.6c23.4-11.6,77.1,9.4,86.2,12.4c55.2,18.1,299.5,102.8,661.2,218.1"
		/>
		<path
			className="st0"
			d="M1475.1,916.9c-47-284.9-81.5-503.2-93.6-579c-1.7-10.8-6.1-38.3,9.5-53.9c15.9-15.9,52.6-16.1,52.6-16.1h54  c63.6,0.9,117.9,2.9,221.6,23.2c106,20.8,251,48.8,401.8,162.4c192,144.6,268.4,264.3,341.9,368.6c14.3,20.3,64.6,86.5,61,107.9  c-2.3,13.6-35.4,24.4-35.4,24.4l-564.9,251.8"
		/>
		<path
			className="st0"
			d="M859.6,1140.4c112-122.1,224-244.1,336-366.2c-34.8-197.2-67.9-394.3-102.7-591.5  c-4.2-21.8-12.7-69.5-29.8-75.8c-15.1-5.6-55.4,7.3-80.4,17.1c-69.5,27.6-146.5,62.9-227.6,108.4c-66.6,37.5-165,93.3-270.2,184.9  c-72.1,62.8-157.8,131.8-251.1,284.4c-12,19.7-24,41-34.2,59.7c-17.2,31.7-32.5,64.3-45.6,97.9c-7.1,18.1-12.9,35.1-12.7,44.2  c0,27.1,51.7,43.1,54.2,44.4C427.7,1014.2,627.5,1074.2,859.6,1140.4z"
		/>
		<circle className="st0" cx={1559.5} cy={1403.8} r={58.7} />
	</svg>
);

export default DashIconOutline;
